module.exports = __webpack_public_path__ + "media/assets/icons/giftbox-83d201bd091aaabb39ce7c348783b1b7.png";